import clsx from 'clsx'
import styles from './SelectChevron.module.scss'
import { TSizeAll } from 'src/types'

export const SelectChevron = ({ isOpen, size }: { isOpen?: boolean; size: TSizeAll }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(styles.chevron, styles[size], {
      [styles.open]: isOpen,
    })}
  >
    <g clipPath="url(#clip0_30651_8797)">
      <path d="M7.28125 10.7188L3.28125 6.71875C3 6.4375 2.90625 6 3.0625 5.625C3.21875 5.25 3.59375 5 4 5H12C12.4062 5 12.75 5.25 12.9062 5.625C13.0625 6 12.9688 6.4375 12.6875 6.71875L8.6875 10.7188C8.3125 11.125 7.65625 11.125 7.28125 10.7188Z" />
    </g>
    <defs>
      <clipPath id="clip0_30651_8797">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
